import flipcardViewModeUtils from "@/components/tinyMce/plugins/flipcard/flipcardViewModeUtils";
import customCheckboxUtils from "@/components/tinyMce/plugins/customCheckbox/customCheckboxUtils";
import customButtonUtils from "@/components/tinyMce/plugins/customButton/customButtonUtils";
import {customButtonPluginName} from "@/components/tinyMce/plugins/customButton/customButton";
import {customCheckboxPluginName} from "@/components/tinyMce/plugins/customCheckbox/customCheckbox";
import {customPluginNameAttr} from "@/components/tinyMce/plugins/tinyMceCustomPluginsConstants";
import {flipcardPluginName} from "@/components/tinyMce/plugins/flipcard/flipcardConstants";

export interface ActiveCustomPlugins {
  customButton: boolean;
  customCheckbox: boolean,
  flipcard: boolean,
}

const handleActiveCustomPluginsStates = (htmlSource: string): ActiveCustomPlugins => {
  return {
    customButton: customButtonContentExist(htmlSource),
    customCheckbox: customCheckboxContentExist(htmlSource),
    flipcard: flipcardContentExist(htmlSource),
  } as ActiveCustomPlugins;
}

const applyViewModeTransformation = (htmlSource: string, activeCustomPlugins: ActiveCustomPlugins, lang: string, doc: Document = document): string => {
  if (activeCustomPlugins.flipcard) {
    htmlSource = flipcardViewModeUtils.toggleFlipCardViewerMode(htmlSource, lang, doc);
  }
  return htmlSource;
}

const loadViewModeAssets = (activeCustomPlugins: ActiveCustomPlugins, doc: Document = document) => {
  if (activeCustomPlugins.flipcard) {
    flipcardViewModeUtils.loadFlipCardViewModeAssets(doc);
  }
  if (activeCustomPlugins.customCheckbox) {
    customCheckboxUtils.loadCheckboxViewModeAssets(doc);
  }
  if (activeCustomPlugins.customButton) {
    customButtonUtils.loadButtonViewModeAssets(doc);
  }
}

const enablePluginsViewerModeEvents = (activeCustomPlugins: ActiveCustomPlugins, doc: Document = document) => {
  if (activeCustomPlugins.flipcard) {
    flipcardViewModeUtils.setViewModeEvents(doc);
  }
}

const customButtonContentExist = (htmlSource: string) => {
  return pluginContentExists(htmlSource, customButtonPluginName);
}

const customCheckboxContentExist = (htmlSource: string) => {
  return pluginContentExists(htmlSource, customCheckboxPluginName);
}
const flipcardContentExist = (htmlSource: string) => {
  return pluginContentExists(htmlSource, flipcardPluginName);
}

const pluginContentExists = (htmlSource: string, pluginName: string) => {
  return htmlSource.includes(`${customPluginNameAttr}="${pluginName}"`);
}

export default {
  handleActiveCustomPluginsStates,
  applyViewModeTransformation,
  loadViewModeAssets,
  enablePluginsViewerModeEvents
}
